import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledNotification = styled.div`
    margin: 0 0 1rem 0;
`;

const Notification = (props) => {
    return (
        <StyledNotification>
            { props.children }
        </StyledNotification>
    );
};

Notification.propTypes = {
    children: PropTypes.node,
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/ui/general/Notification.js